import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import Accordions from '../Accordions/Accordions';
import PointsList from '../PointsList/PointsList';
import { GatsbyImage } from 'gatsby-plugin-image';
import { styles } from './styles';
import { capitalizeText } from '../../helpers/lib';

export default function PrecourseProgramWeekCard({
  card,
  isMobile,
  pointIcon,
  image,
  cardStyle,
}) {
  const CardContent = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: { xs: 2, lg: 3 },
        mt: 2,
      }}
    >
      {card.week.map(({ title, points }) => (
        <Box sx={{ flex: 1, pb: 1 }}>
          <Typography variant="desktopH5">{title}</Typography>
          <Points
            points={isMobile ? [capitalizeText(points.join(', '))] : points}
            pointIcon={pointIcon}
          />
        </Box>
      ))}
    </Box>
  );

  return (
    <Box sx={cardStyle || styles.root}>
      {isMobile ? (
        <Accordions
          sx={styles.accordions(card.isLastCard)}
          summary={<DayPlate day={card.title} />}
          details={<CardContent />}
        />
      ) : (
        <Paper
          elevation={0}
          sx={{
            ...styles.paper,
            backgroundColor: card.isLastCard
              ? 'kit.background.middlepurple'
              : 'kit.background.white',
          }}
        >
          <DayPlate day={card.title} />
          <CardContent />
        </Paper>
      )}
    </Box>
  );
}

const DayPlate = ({ day }) => (
  <Paper elevation={0} sx={styles.day}>
    <Typography
      variant={isMobile ? 'mobileH3' : 'desktopH4'}
      color={'kit.text.mainInverse'}
    >
      {day}
    </Typography>
  </Paper>
);

const Points = ({ points, pointIcon }) => (
  <Box sx={{ mt: 2 }}>
    <PointsList list={points} pointIcon={pointIcon} textProps={styles.points} />
  </Box>
);
